import cs from './cs/index'
import en from './en/index'

export default {
    cs,
    en
}
